module.exports = "../images/bear@2x.png?v=edf639e";